<template>
  <div class="headerBoxCasamento row no-gutters">
    <span class=" pt-3 conjugeTitle"> {{ ` ${this.infoTitle} ` }} </span>
    <span class="pt-1 conjugeInfo">
      {{ ` ${this.infoName} ` }}
    </span>
    <span class="pt-2 conjugeInfo_text">
      {{ ` ${this.infoCpf} ` }}
    </span>
  </div>
</template>

<script>
  export default {
    name: "HeaderBoxCasamento",
    props: ['infoName', 'infoCpf', 'infoTitle'],
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/exports';
  .habilitacaoTitle{
    position: relative;
    top:95px;
  }
  .headerBoxCasamento{
    max-width: 50rem;
  }

  .conjugeTitle{
    border-bottom: 0.0625rem solid white;
       padding-top: 7px;
       padding-bottom: 2px;
       margin-bottom: 2px;
       font-size: 0.875rem;
  }

  .conjugeInfo{
    display: inline-block;
      line-height: pxToRem(14);
      min-height: pxToRem(14);
      width: 100%;
      font-size: 20px;

      &_name{
        font-size: 20px;
      }
      &_text{
        font-size: 14px;
      }
  }

  .hideMe {
    visibility: hidden;
  }
</style>
